<template>
  <div>
    <!-- 支付订单管理 -->
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>支付订单管理</span>
          </div>
        </div>
      </template>

      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>订单号</span>
          <a-input v-model.trim="paramsData.serialNo" placeholder="请输入订单号" allow-clear/>
        </div>
        <div class="item">
          <span>支付类型</span>
          <a-select v-model="paramsData.payType" placeholder="请选择" allow-clear style="width: 160px">
            <a-select-option v-for="(item, key) in payOrderDict.payType" :key="key" :value="key" v-if="item.show">
              <a-tag :color="item.color">{{ item.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>订单状态</span>
          <a-select v-model="paramsData.status" placeholder="请选择" allow-clear style="width: 120px">
            <a-select-option v-for="(item, key) in payOrderDict.payStatus" :key="key" :value="key" v-if="item.show">
              <a-tag :color="item.color">{{ item.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="item">
          <span>付款账号</span>
          <a-input v-model.trim="paramsData.accountNo" placeholder="请输入" allow-clear style="width: 140px"/>
        </div>
        <div class="item">
          <span>收款账号</span>
          <a-input v-model.trim="paramsData.oppAccountNo" placeholder="请输入" allow-clear style="width: 140px"/>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :loading="loading"
              :pagination="false"
              :scroll="{ x: 1200 }"
              row-key="id"
          >
            <!-- 订单号 -->
            <template slot="serialNo" slot-scope="text, record">
              <a-button style="color: #1890ff;" type="link" @click="viewBtn(record)">{{ text }}</a-button>
            </template>

            <!-- 支付类型 -->
            <template slot="payType" slot-scope="text">
              <a-tag :color="getPayTypeCfg(text).color">
                {{ getPayTypeCfg(text).label }}
              </a-tag>
            </template>

            <!-- 订单状态 -->
            <template slot="status" slot-scope="text">
              <a-tag :color="getStatusCfg(text).color">
                {{ getStatusCfg(text).label }}
              </a-tag>
            </template>

            <!-- 支付金额 -->
            <template slot="payAmount" slot-scope="text">
              <span class="amount-primary">{{ formatAmount(text) }}</span>
            </template>

            <!-- 手续费金额 -->
            <template slot="feeAmount" slot-scope="text">
              <span class="amount-warning">{{ formatAmount(text) }}</span>
            </template>

            <!-- 手续费状态 -->
            <template slot="feeStatus" slot-scope="text,record">
              <a-tag :color="getFeeStatusCfg(text).color">
                {{ getFeeStatusCfg(text).label }}
              </a-tag>
              <a-button icon="reload"   style="color: #1890ff;" type="link" v-if="record.feeStatus==='1' || record.feeStatus=== '2'" @click="retryFeeBtn(record)"/>
            </template>

            <!-- 操作 -->
            <template slot="action" slot-scope="text, record">
              <a-button icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)">详情</a-button>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页 -->
      <div class="paginationBox">
        <LcfsPagination
            :page-no.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.total"
            :fn="getTableData"
        />
      </div>
    </a-card>

    <!-- 详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        title="订单详情"
        @cancel="viewModalVisible = false"
        width="800px"
        :footer="null"
        :destroyOnClose="true"
    >
      <div v-if="viewData" class="order-detail">
        <a-card title="基本信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="订单号" :span="2">
              <a @click="copyText(viewData.serialNo)" class="copy-text">{{ viewData.serialNo }}</a>
            </a-descriptions-item>
            <a-descriptions-item label="支付类型">
              <a-tag :color="getPayTypeCfg(viewData.payType).color">
                {{ getPayTypeCfg(viewData.payType).label }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="订单状态">
              <a-tag :color="getStatusCfg(viewData.status).color">
                {{ getStatusCfg(viewData.status).label }}
              </a-tag>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <a-card title="付款信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="付款账号" :span="2">{{ viewData.accountNo }}</a-descriptions-item>
            <a-descriptions-item label="付款户名" :span="2">{{ viewData.accountName }}</a-descriptions-item>
            <a-descriptions-item label="支付金额" :span="2">
              <span class="amount-primary amount-lg">{{ formatAmount(viewData.payAmount) }} 元</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-card>

        <a-card title="收款信息" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="收款账号" :span="2">{{ viewData.oppAccountNo }}</a-descriptions-item>
            <a-descriptions-item label="收款户名" :span="2">{{ viewData.oppAccountName }}</a-descriptions-item>
            <a-descriptions-item label="收款银行">{{ viewData.oppBankName || '-' }}</a-descriptions-item>
            <a-descriptions-item label="收款行号">{{ viewData.oppBankNo || '-' }}</a-descriptions-item>
          </a-descriptions>
        </a-card>

        <a-card title="手续费信息" v-if="$authority('feeView')" size="small" :bordered="false" class="detail-section">
          <a-descriptions bordered :column="2" size="small">
            <a-descriptions-item label="手续费金额">
              <span class="amount-warning">{{ formatAmount(viewData.feeAmount) }}</span>
            </a-descriptions-item>
            <a-descriptions-item label="手续费状态">
              <a-tag :color="getFeeStatusCfg(viewData.feeStatus).color">
                {{ getFeeStatusCfg(viewData.feeStatus).label }}
              </a-tag>
              <a-button icon="reload"   style="color: #1890ff;" type="link" v-if="viewData.feeStatus==='1' || viewData.feeStatus=== '2'" @click="retryFeeBtn(viewData)"/>

            </a-descriptions-item>
            <a-descriptions-item label="手续费付款账号" :span="2">{{ viewData.feePayerAccountNo || '-' }}</a-descriptions-item>
            <a-descriptions-item label="手续费付款户名" :span="2">{{ viewData.feePayerAccountName || '-' }}</a-descriptions-item>
            <a-descriptions-item label="手续费收款账号" :span="2">{{ viewData.feeAccountNo || '-' }}</a-descriptions-item>
            <a-descriptions-item label="手续费收款户名" :span="2">{{ viewData.feeAccountName || '-' }}</a-descriptions-item>
            <a-descriptions-item label="创建时间" :span="2">{{ viewData.createTime }}</a-descriptions-item>
          </a-descriptions>
        </a-card>
      </div>
      <div v-else class="empty-state">
        <a-empty description="暂无数据"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import {payOrderDict} from "@/utils/bizDict/payOrderDict";

export default {
  name: 'payOrder',
  components: {LcfsPagination, WalletInfo},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      loading: false,

      // 筛选参数
      paramsData: {
        serialNo: "",
        payType: "",
        status: "",
        accountNo: "",
        oppAccountNo: "",

      },

      // 表格数据
      tableData: [],

      // 详情弹窗
      viewModalVisible: false,
      viewData: null,

      // 字典引用
      payOrderDict,

      // 表格列配置
      columns: [

        {title: "支付类型", dataIndex: "payType", key: "payType", width: 140, align: 'center', scopedSlots: {customRender: 'payType'}},
        {title: "订单号", dataIndex: "serialNo", key: "serialNo", width: 200, align: 'center', ellipsis: true, scopedSlots: {customRender: 'serialNo'}},
        {
          title: "付款账号", dataIndex: "accountNo", key: "accountNo", width: 150, align: 'center', ellipsis: true, customRender: (text, row) => {
            if (!text) return '-';
            return <WalletInfo accountNo={text} accountName={row.accountName} showAccountNo={true} showAccountName={true}/>;
          }
        },
        {title: "金额", dataIndex: "payAmount", key: "payAmount", align: 'center', width: 110, scopedSlots: {customRender: 'payAmount'}},
        {
          title: "收款账号", dataIndex: "oppAccountNo", key: "oppAccountNo", align: 'center', width: 150, ellipsis: true, customRender: (text, row) => {
            if (!text) return '-';
            return <WalletInfo accountNo={text} accountName={row.oppAccountName} showAccountNo={true} showAccountName={true}/>;
          }
        },
        {title: "状态", dataIndex: "status", key: "status", width: 90, align: 'center', scopedSlots: {customRender: 'status'}},
        ...(this.$authority('feeView') ? [
          {
            title: "手续费付款账号",
            dataIndex: "feePayerAccountNo",
            key: "feePayerAccountNo",
            align: 'center',
            width: 150,
            ellipsis: true,
            customRender: (text, row) => {
              if (!text && row.feeStatus !== '0') return <WalletInfo accountNo={row.accountNo} accountName={row.accountName} showAccountNo={true}
                                                                     showAccountName={true}/>;
              return <WalletInfo accountNo={text} accountName={row.feePayerAccountName} showAccountNo={true} showAccountName={true}/>;
            }
          },
          {title: "手续费", dataIndex: "feeAmount", key: "feeAmount", align: 'center', width: 90, scopedSlots: {customRender: 'feeAmount'}},
          {title: "手续费状态", dataIndex: "feeStatus", key: "feeStatus", align: 'center', width: 90, scopedSlots: {customRender: 'feeStatus'}},

          {
            title: "手续费收款账号", dataIndex: "feeAccountNo", key: "feeAccountNo", align: 'center', width: 150, ellipsis: true, customRender: (text, row) => {
              if (!text) return '-';
              return <WalletInfo accountNo={text} accountName={row.feeAccountName} showAccountNo={true} showAccountName={true}/>;
            }
          },
        ] : []),

        {title: "创建时间", dataIndex: "createTime", align: 'center', key: "createTime", width: 160},
        // {title: "操作", key: "action", width: 80, align: 'center', scopedSlots: {customRender: 'action'}},
      ],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    async getTableData() {
      this.loading = true;
      try {
        const res = await this.api.payOrderPageApi(
            this.pagination.pageNo,
            this.pagination.pageSize,
            this.paramsData
        );
        if (res.code === 200) {
          this.tableData = res.data?.records || [];
          this.pagination.total = res.data?.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        serialNo: "",
        payType: "",
        status: "",
        accountNo: "",
        oppAccountNo: "",
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    // 查看详情
    async viewBtn(record) {
      try {
        const res = await this.api.payOrderDetailApi(record.id);
        if (res.code === 200) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        message.error("获取详情失败");
      }
    },
    // 服务费重试
    async retryFeeBtn(record) {
      var that = this;
      this.$confirm({
        title: '确认重试服务费？',
        content: () => "是否重新尝试收取该订单的服务费？",
        onOk: async () => {
          try {
            console.log("record", record)
            const res = await that.api.payRetryFeepi(record.serialNo);
            if (res.code === 200) {
              message.success(res.info || "服务费重试操作成功");
              that.getTableData()
            } else {
              message.warning(res.info || "服务费重试失败");
            }
          } catch (error) {
            console.error("服务费重试失败:", error);
            message.error("服务费重试失败");
          }
        },
        onCancel() {
          console.log('用户取消了重试操作');
        },
      });
    },


    // 复制文本
    copyText(text) {
      navigator.clipboard.writeText(text).then(() => {
        message.success('复制成功');
      }).catch(() => {
        message.error('复制失败');
      });
    },

    // 支付类型配置
    getPayTypeCfg(type) {
      return payOrderDict.payType[type] || payOrderDict.payType.default;
    },

    // 订单状态配置
    getStatusCfg(status) {
      return payOrderDict.payStatus[status] || payOrderDict.payStatus.default;
    },

    // 手续费状态配置
    getFeeStatusCfg(status) {
      return payOrderDict.feeStatus[status] || payOrderDict.feeStatus.default;
    },

    // 金额格式化
    formatAmount(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toFixed(2);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 16px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 160px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.order-detail {
  max-height: 70vh;
  overflow-y: auto;
  padding: 4px;

  .detail-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .amount-primary {
    color: #1890ff;
    font-weight: 500;
  }

  .amount-warning {
    color: #faad14;
  }

  .amount-lg {
    font-size: 16px;
    font-weight: bold;
  }

  .copy-text {
    cursor: pointer;
    color: #1890ff;

    &:hover {
      text-decoration: underline;
    }
  }
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
</style>